var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';


const GrabDoubleIcon = ({ className, color }) => /*#__PURE__*/
_jsx("svg", {
  className: className || '',
  xmlns: "http://www.w3.org/2000/svg",
  fill: `${color}`,
  stroke: `${color}`,
  viewBox: "0 0 10 39" }, void 0, /*#__PURE__*/

_jsx("path", {
  d: "M2 10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M2 17C2.55228 17 3 16.5523 3 16C3 15.4477 2.55228 15 2 15C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M8 10C8.55228 10 9 9.55228 9 9C9 8.44772 8.55228 8 8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M8 3C8.55228 3 9 2.55228 9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2C7 2.55228 7.44772 3 8 3Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M8 17C8.55228 17 9 16.5523 9 16C9 15.4477 8.55228 15 8 15C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M2 31C2.55228 31 3 30.5523 3 30C3 29.4477 2.55228 29 2 29C1.44772 29 1 29.4477 1 30C1 30.5523 1.44772 31 2 31Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M2 24C2.55228 24 3 23.5523 3 23C3 22.4477 2.55228 22 2 22C1.44772 22 1 22.4477 1 23C1 23.5523 1.44772 24 2 24Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M2 38C2.55228 38 3 37.5523 3 37C3 36.4477 2.55228 36 2 36C1.44772 36 1 36.4477 1 37C1 37.5523 1.44772 38 2 38Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M8 31C8.55228 31 9 30.5523 9 30C9 29.4477 8.55228 29 8 29C7.44772 29 7 29.4477 7 30C7 30.5523 7.44772 31 8 31Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M8 24C8.55228 24 9 23.5523 9 23C9 22.4477 8.55228 22 8 22C7.44772 22 7 22.4477 7 23C7 23.5523 7.44772 24 8 24Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M8 38C8.55228 38 9 37.5523 9 37C9 36.4477 8.55228 36 8 36C7.44772 36 7 36.4477 7 37C7 37.5523 7.44772 38 8 38Z",
  stroke: `${color}`,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
)
);


export { GrabDoubleIcon };